export { GeminiProvider } from './gemini';
export type { GeminiProviderOptions } from './gemini';
export { MinimaxProvider } from './minimax';
export type { MinimaxProviderOptions } from './minimax';

import type { LLMProvider } from '../agent/types';
import { GeminiProvider } from './gemini';
import { MinimaxProvider } from './minimax';

/** Provider slugs we know how to instantiate. */
export type ProviderSlug = LLMProvider['slug'];

/** Configuration the user supplies in Settings (Phase 1G). */
export interface ProviderConfig {
  slug: ProviderSlug;
  apiKey: string;
  /** Optional model override; otherwise the provider's default ships. */
  model?: string;
}

/**
 * Factory — given a config, return an LLMProvider instance.
 * Single switch point keeps the rest of the app provider-agnostic.
 */
export function createProvider(cfg: ProviderConfig): LLMProvider {
  switch (cfg.slug) {
    case 'gemini':
      return new GeminiProvider({ apiKey: cfg.apiKey, model: cfg.model });
    case 'minimax':
      return new MinimaxProvider({ apiKey: cfg.apiKey, model: cfg.model });
    default: {
      // Exhaustiveness check: if we add a new slug to the union but
      // forget to handle it here, TS errors at the assignment.
      const _exhaustive: never = cfg.slug;
      throw new Error(`Unknown provider slug: ${String(_exhaustive)}`);
    }
  }
}

/** Display metadata for the provider picker UI. */
export const PROVIDER_REGISTRY: Array<{
  slug: ProviderSlug;
  label: string;
  defaultModel: string;
  apiKeyHelpUrl: string;
  apiKeyHelpText: string;
}> = [
  {
    slug: 'minimax',
    label: 'MiniMax',
    defaultModel: 'MiniMax-M1',
    apiKeyHelpUrl: 'https://platform.minimaxi.com/user-center/basic-information/interface-key',
    apiKeyHelpText: '上 platform.minimaxi.com → 個人中心 → 接口密鑰，複製 key 貼落呢度',
  },
  {
    slug: 'gemini',
    label: 'Gemini',
    defaultModel: 'gemini-2.5-flash',
    apiKeyHelpUrl: 'https://aistudio.google.com/apikey',
    apiKeyHelpText: '上 aistudio.google.com/apikey 一鍵生成 key（Google account login）',
  },
];
